'use client';
import { useState, useEffect, useRef } from 'react';
import { GlossaryType } from '@scitrials-sst/core/Next/types';
import styles from './glossary.module.css';
import { data } from './data';

export default function Glossary({
	glossaries,
}: {
	glossaries: GlossaryType[];
}) {
	const [isOpen, setIsOpen] = useState(false);
	const [searchTerm, setSearchTerm] = useState('');
	const glossaryRef = useRef<HTMLDivElement>(null);

	const filteredItems = glossaries
		.filter(
			(entry) =>
				entry.title.toLowerCase().includes(searchTerm.toLocaleLowerCase()) ||
				entry.definition.toLowerCase().includes(searchTerm.toLocaleLowerCase())
		)
		.sort((a, b) => a.title.toLowerCase().localeCompare(b.title.toLowerCase()));

	function highlightText(text: string) {
		if (!searchTerm) return text;

		const regex = new RegExp(`(${searchTerm})`, 'gi');
		const parts = text.split(regex);

		return parts.map((part, i) =>
			part.toLowerCase() === searchTerm.toLowerCase() ? (
				<mark
					key={i}
					style={{ backgroundColor: '#446cb366', padding: '0 2px' }}
				>
					{part}
				</mark>
			) : (
				part
			)
		);
	}

	// close on click outside
	useEffect(() => {
		function handleClickOutside(event: MouseEvent) {
			if (
				glossaryRef.current &&
				!glossaryRef.current.contains(event.target as Node) &&
				isOpen
			) {
				setIsOpen(false);
			}
		}

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [isOpen]);

	return (
		<div className={styles['glossary-container']} ref={glossaryRef}>
			<div
				className={`${styles['glossary-panel']} ${isOpen ? styles.open : ''}`}
			>
				<div className={styles['search-container']}>
					<input
						type='text'
						placeholder='Search Glossary'
						value={searchTerm}
						onChange={(e) => setSearchTerm(e.target.value)}
						className={styles['search-input']}
					/>
				</div>

				<div className={styles['glossary-content']}>
					{glossaries.length === 0 ? (
						<p className={styles['no-results']}>No glossaries at the moment</p>
					) : filteredItems.length > 0 ? (
						filteredItems.map((item, index) => (
							<div key={index} className={styles['glossary-item']}>
								<p className={styles['glossary-title']}>
									{highlightText(item.title)}
								</p>
								<p className={styles['glossary-description']}>
									{highlightText(item.definition)}
								</p>
								{index < filteredItems.length - 1 && (
									<hr
										style={{
											margin: '0.5rem 0',
										}}
									/>
								)}
							</div>
						))
					) : (
						<p className={styles['no-results']}>No matching terms found</p>
					)}
				</div>
			</div>

			<div
				className={`${styles['glossary-tab']} ${
					isOpen ? styles['tab-open'] : ''
				}`}
				onClick={() => setIsOpen((prev) => !prev)}
			>
				<div className={styles['tab-text']}>
					<p>G</p>
					<p>l</p>
					<p>o</p>
					<p>s</p>
					<p>s</p>
					<p>a</p>
					<p>r</p>
					<p>y</p>
				</div>
			</div>
		</div>
	);
}
